/**
 * Handles the click event for touch-capable devices.
 * Prevents the default action of the event on touch devices to allow for other interactions
 * (like opening a dropdown) to occur instead of immediate navigation.
 */
export const handleTouchCapableClick = event => {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    event.preventDefault();
  }
};
//# sourceMappingURL=utils.js.map